import React, { useState, useEffect } from "react";
import {
  Wrapper,
  Title,
  ContentMessage,
  IphoneMessege,
  Messege,
  Tags,
  TopPart,
  TagsWrapper,
  Tag,
  Buttons,
  SaveAsDraft,
  Send,
  Previous,
  TagsScrollArea,
} from "./Theme";
import {
  PushPreview,
  PushTitle,
  PushBody,
  PushLinkFields,
  PushLinkSectionTitle,
  PushLinkLabel,
  PushLinkInput,
  FieldSelector,
  CharacterCount,
  DynamicTextSection,
} from "pages/Communication/Components/Campaigns/CreateCampaign/TextMessege/SendTextMessege/Theme";
import iphoneImage from "assets/icons/IphoneImage.png";
import { useDispatch, useSelector } from "react-redux";
import { default as FinanceSetting } from "Lib/API/FinanceSetting/FinanceSetting";
import { useAuth0 } from "@auth0/auth0-react";
import { toastr } from "react-redux-toastr";
import { setDataAfterCreatedCampaign } from "services/api/communication";
import CommunicationService from "Lib/API/Communication/index";
import CircularProgress from "@mui/material/CircularProgress";
import { setCardContent } from "services/api/communication";

export const SendTextMessege = ({
  onBack,
  formik,
  setCardName,
  automationType = "sms",
}) => {
  const organization = JSON.parse(localStorage.getItem("organization"));
  const { getAccessTokenSilently } = useAuth0();
  const [tokensList, setTokenList] = useState([]);
  const [createAutomationLoading, setCreateAutomationLoading] = useState(false);
  const [createAutomationDraftLoading, setCreateAutomationDraftLoading] =
    useState(false);
  const dispatch = useDispatch();
  const { automationEditData } = useSelector((state) => state.communication);
  const [textAreaContent, setTextAreaContent] = useState(
    automationEditData?.message || ""
  );
  const [titleContent, setTitleContent] = useState(
    automationEditData?.subject || ""
  );
  const [linkTitle, setLinkTitle] = useState(automationEditData?.linkTitle || "");
  const [linkUrl, setLinkUrl] = useState(automationEditData?.linkUrl || "");
  const [dynamicField, setDynamicField] = useState("title");
  const isPush = automationType === "push";

  const getTemplateTokens = async () => {
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateTokens(
        token,
        "communication"
      );
      setTokenList(response?.result);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };
  useEffect(() => {
    getTemplateTokens();
  }, []);

  const handleDoubleClick = (tag) => {
    if (isPush && dynamicField === "title") {
      if (`${titleContent}${tag}`.length > 30) {
        toastr.warning("Title limit", "This dynamic field does not fit in the title");
        return;
      }
      setTitleContent((previous) => `${previous}${tag}`);
      return;
    }
    if (isPush && `${textAreaContent}${tag}`.length > 240) {
      toastr.warning("Body limit", "This dynamic field does not fit in the body");
      return;
    }
    setTextAreaContent((prevContent) => `${prevContent}${tag}`);
  };
  const handleTextAreaChange = (event) => {
    setTextAreaContent(event.target.value);
  };

  const createAutomation = async (isDraft) => {
    isDraft
      ? setCreateAutomationDraftLoading(true)
      : setCreateAutomationLoading(true);
    const token = await getAccessTokenSilently();
    const data = {
      isDraft: isDraft,
      data: {
        automationName: formik.values?.automationName,
        automationType,
        audiences:
          formik.values?.account?.audiences[0] === "-1"
            ? []
            : formik.values?.account?.audiences?.map((val) => val._id),
        allAudiences: formik.values?.account?.audiences[0] === "-1",
        message: textAreaContent,
        eventType: formik.values?.eventType?.value,
        subject: isPush ? titleContent : formik.values?.subject,
        ...(isPush && { linkTitle, linkUrl }),
        timeExecute: {
          timeType: formik.values?.timeExecute?.timeType?.toLowerCase(),
          unit:
            formik.values?.timeExecute?.timeType === "on the day"
              ? 0
              : formik.values?.timeExecute?.unit,
          timePeriod:
            formik.values?.timeExecute?.timeType === "on the day"
              ? ""
              : formik.values?.timeExecute?.timePeriod?.toLowerCase(),
        },
      },
    };
    const finalresult =
      Object.keys(automationEditData).length > 0
        ? { id: automationEditData?._id, ...data }
        : data;
    try {
      const response =
        Object.keys(automationEditData).length > 0
          ? await CommunicationService.updateAutomation(finalresult, token)
          : await CommunicationService.createAutomation(finalresult, token);
      isDraft
        ? setCreateAutomationDraftLoading(false)
        : setCreateAutomationLoading(false);
      Object.keys(automationEditData).length > 0
        ? toastr.success("Success", "Automation updated sucessfully")
        : toastr.success("Success", "Automation created sucessfully");
      dispatch(setDataAfterCreatedCampaign(response?.result));
      dispatch(setCardContent("Done"));
      setCardName && setCardName(automationType);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
      isDraft
        ? setCreateAutomationDraftLoading(false)
        : setCreateAutomationLoading(false);
    }
  };
  const isEmpty =
    textAreaContent === "" || (isPush && titleContent === "");
  return (
    <Wrapper>
      <TopPart>
        <Title>
          {isPush ? "Set Automated Push Notification" : "Set Automated Text Message"}
        </Title>
      </TopPart>

      <ContentMessage>
        {isPush ? (
          <IphoneMessege image={iphoneImage}>
            <span>{organization?.orgName}</span>
            <PushPreview>
              <div className="notification">
                <div className="notification-header">
                  <div className="app-icon">
                    {organization?.orgName?.charAt(0) || "E"}
                  </div>
                  <div className="notification-content">
                    <PushTitle
                      aria-label="Notification title"
                      data-active={dynamicField === "title"}
                      placeholder="Notification title"
                      maxLength={30}
                      value={titleContent}
                      onFocus={() => setDynamicField("title")}
                      onChange={(event) => setTitleContent(event.target.value)}
                    />
                    <CharacterCount>Max 30 characters</CharacterCount>
                  </div>
                </div>
                <PushBody
                  aria-label="Notification body"
                  data-active={dynamicField === "body"}
                  placeholder="Notification body"
                  maxLength={240}
                  value={textAreaContent}
                  onFocus={() => setDynamicField("body")}
                  onChange={handleTextAreaChange}
                />
                <CharacterCount>Max 240 characters</CharacterCount>
              </div>
            </PushPreview>
          </IphoneMessege>
        ) : (
          <IphoneMessege image={iphoneImage}>
            <span>{organization?.orgName}</span>
            <Messege
              placeholder="Add your text here"
              value={textAreaContent}
              onChange={handleTextAreaChange}
            />
          </IphoneMessege>
        )}
        <TagsWrapper>
          {isPush ? (
            <TagsScrollArea>
              <PushLinkSectionTitle>Link (optional)</PushLinkSectionTitle>
              <PushLinkFields>
                <PushLinkLabel>
                  Link label
                  <PushLinkInput
                    type="text"
                    placeholder="e.g. View details"
                    maxLength={50}
                    value={linkTitle}
                    onChange={(event) => setLinkTitle(event.target.value)}
                  />
                </PushLinkLabel>
                <PushLinkLabel>
                  Link URL
                  <PushLinkInput
                    type="text"
                    placeholder="https:// or {{link}}"
                    maxLength={2048}
                    value={linkUrl}
                    onChange={(event) => setLinkUrl(event.target.value)}
                  />
                </PushLinkLabel>
              </PushLinkFields>
              <DynamicTextSection>
                <span>Dynamic Text : </span>
                <FieldSelector>
                  <legend>Add dynamic text to:</legend>
                  <label data-active={dynamicField === "title"}>
                    <input
                      type="radio"
                      name="dynamicField"
                      value="title"
                      checked={dynamicField === "title"}
                      onChange={(event) => setDynamicField(event.target.value)}
                    />{" "}
                    Title
                  </label>
                  <label data-active={dynamicField === "body"}>
                    <input
                      type="radio"
                      name="dynamicField"
                      value="body"
                      checked={dynamicField === "body"}
                      onChange={(event) => setDynamicField(event.target.value)}
                    />{" "}
                    Body
                  </label>
                </FieldSelector>
                <span>Double click to add to the {dynamicField}</span>
                <Tags>
                  {tokensList?.map((tag) => (
                    <Tag
                      type="button"
                      key={tag?.value}
                      onDoubleClick={() => handleDoubleClick(tag?.value)}
                    >
                      {tag?.name}
                    </Tag>
                  ))}
                </Tags>
              </DynamicTextSection>
            </TagsScrollArea>
          ) : (
            <TagsScrollArea>
              <span>Dynamic Text : </span>
              <br />
              <br />
              <span>double click to add to the message</span>
              <Tags>
                {tokensList?.map((tag) => (
                  <Tag
                    type="button"
                    key={tag?.value}
                    onDoubleClick={() => handleDoubleClick(tag?.value)}
                  >
                    {tag?.name}
                  </Tag>
                ))}
              </Tags>
            </TagsScrollArea>
          )}
          <Buttons>
            <Previous onClick={onBack}>Previous</Previous>
            <>
              <SaveAsDraft
                onClick={() => createAutomation(true)}
                disabled={isEmpty}
                textAreaContent={isEmpty ? "" : textAreaContent}
              >
                {createAutomationDraftLoading ? (
                  <div className="d-flex justify-content-center w-100">
                    <CircularProgress
                      size={22}
                      style={{
                        color: "var(--Blues-Blue-Main, #2555EF)",
                      }}
                    />
                  </div>
                ) : (
                  "Save as a draft"
                )}
              </SaveAsDraft>
              <Send
                onClick={() => createAutomation(false)}
                disabled={isEmpty}
                textAreaContent={isEmpty ? "" : textAreaContent}
              >
                {createAutomationLoading ? (
                  <div className="d-flex justify-content-center w-100">
                    <CircularProgress size={22} style={{ color: "#ffffff" }} />
                  </div>
                ) : (
                  "Set"
                )}
              </Send>
            </>
          </Buttons>
        </TagsWrapper>
      </ContentMessage>
    </Wrapper>
  );
};
